<app-filter
    [form]="form"
    [filters]="filters"
    [sessionUser$]="sessionUser$"
    [productFieldKey]="productFieldKey"
    [businessFieldKey]="businessFieldKey"
    [supplierFieldKey]="supplierFieldKey"
    [provinceFieldKey]="provinceFieldKey"
    [wholesalerFieldKey]="wholesalerFieldKey"
    [storeFieldKey]="storeFieldKey"
    [presetRanges]="presetRanges"
    [showAdvancedFilters]="showAdvancedFilters"
    [searchItems]="searchItems"
    (submitSearch)="submit()"
    [isClearing]="isClearingFilters"
    (clear)="clearFilters()"
    (onChangeEvent)="onChange($event.event, $event.key)"
    (onClearEvent)="onClear($event)"
    (toggle)="toggleOption()"
    (removeItem)="removeSearchItem($event.key, $event.item)">
</app-filter>

<button class="btn export-btn mb-2" (click)="exportChartsToPDF()" [disabled]="isExporting">
    <span
        *ngIf="isExporting"
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"></span>
    {{ isExporting ? 'Exporting PDF...' : 'Export Charts to PDF' }}
</button>

<ejs-dashboardlayout
    id="salesDashboardLayout"
    #defaultLayout
    [cellSpacing]="cellSpacing"
    [columns]="columns"
    [allowDragging]="allowDragging">
    <e-panels>
        <e-panel [sizeX]="3" [sizeY]="1" [row]="0" [col]="0">
            <ng-template #header>
                <div style="display: flex; justify-content: space-between; align-items: center">
                    <span>Cashback vs Date</span>
                    <span style="font-weight: bold">
                        Total Sales :
                        {{ sumSales(svdChartData) | currency: 'ZAR' : 'symbol' : '1.2-2' }}
                    </span>
                </div>
            </ng-template>
            <ng-template #content>
                <div
                    class="syncfusion-progressbar"
                    *ngIf="isBusy; else cvdChartContainer">
                    <ejs-progressbar
                        id="svdChartProgressBar"
                        [type]="progressBarType"
                        [height]="progressBarHeight"
                        [value]="progressBarValue"
                        [progressColor]="progressColor"
                        [isIndeterminate]="isIndeterminate"
                        [animation]="animation">
                    </ejs-progressbar>
                </div>
                <ng-template #cvdChartContainer>
                    <ejs-chart
                        *ngIf="chartReady && svdChartData?.length > 0"
                        #cvdChart
                        id="cvdChartContainer"
                        [width]="widthValue"
                        [height]="heightValue"
                        [primaryXAxis]="svdPrimaryXAxis"
                        [primaryYAxis]="svdPrimaryYAxis"
                        [zoomSettings]="zoomSettings"
                        [tooltip]="svdTooltip"
                        [legendSettings]="svdLegendSettings"
                        (textRender)="chartUtils.onTextRender($event)"
                        (axisLabelRender)="chartUtils.onAxisLabelRender($event)"
                        [tooltip]="{ enable: true }"
                        (tooltipRender)="chartUtils.onTooltipRender($event)"
                        (load)="chartLoad($event)">
                        <e-series-collection>
                            <e-series
                                [dataSource]="svdChartData"
                                type="Column"
                                xName="date"
                                yName="sales"
                                name="Cashback"
                                [marker]="{ dataLabel: { visible: true } }">
                            </e-series>
                        </e-series-collection>
                    </ejs-chart>
                </ng-template>
            </ng-template>
        </e-panel>

        <e-panel [sizeX]="3" [sizeY]="1" [row]="1" [col]="0">
            <ng-template #header>
                <div>Cashback By Province</div>
            </ng-template>
            <ng-template #content>
                <div
                    class="syncfusion-progressbar"
                    *ngIf="isBusy; else cashbackPerStoreContainer">
                    <ejs-progressbar
                        id="cashbackPerStoreProgressBar"
                        [type]="progressBarType"
                        [height]="progressBarHeight"
                        [value]="progressBarValue"
                        [progressColor]="progressColor"
                        [isIndeterminate]="isIndeterminate"
                        [animation]="animation">
                    </ejs-progressbar>
                </div>
                <ng-template #cashbackPerStoreContainer>
                    <ejs-accumulationchart
                        *ngIf="chartReady && pieChartData?.length > 0"
                        id="cashbackByProvince"
                        (load)="pieChartLoad($event)"
                        (textRender)="this.chartUtils.onAccumulationChartTextRender($event)"
                        #cashbackByProvincePieChart
                        [width]="widthValue"
                        [height]="heightValue"
                        [legendSettings]="pieChartLegendSettings"
                        [enableSmartLabels]="enableSmartLabel"
                        [center]="center">
                        <e-accumulation-series-collection>
                            <e-accumulation-series
                                name="cashbackPerProvince"
                                [dataSource]="pieChartData"
                                xName="name"
                                yName="value"
                                [startAngle]="startAngle"
                                [endAngle]="endAngle"
                                innerRadius="40%"
                                radius="80%"
                                [dataLabel]="pieDataLabel"
                                [explode]="explode"
                                explodeOffset="10%"
                                [explodeIndex]="2">
                            </e-accumulation-series>
                        </e-accumulation-series-collection>
                    </ejs-accumulationchart>
                </ng-template>
            </ng-template>
        </e-panel>

        <e-panel [sizeX]="3" [sizeY]="1" [row]="2" [col]="0">
            <ng-template #header>
                <div style="display: flex; justify-content: space-between; align-items: center">
                    <span>Cashback By Product</span>
                    <span style="font-weight: bold">
                        Total Sales :
                        {{ sumSales(salesProductList) | currency: 'ZAR' : 'symbol' : '1.2-2' }}
                    </span>
                </div>
            </ng-template>
            <ng-template #content>
                <div
                    class="syncfusion-progressbar"
                    *ngIf="isBusy; else topProductsContainer">
                    <ejs-progressbar
                        id="topProductsProgressBar"
                        [type]="progressBarType"
                        [height]="progressBarHeight"
                        [value]="progressBarValue"
                        [progressColor]="progressColor"
                        [isIndeterminate]="isIndeterminate"
                        [animation]="animation">
                    </ejs-progressbar>
                </div>
                <ng-template #topProductsContainer>
                    <ejs-chart
                        *ngIf="chartReady && salesProductList?.length > 0"
                        #productChart
                        id="cashbackByProductChart"
                        [primaryXAxis]="productXAxis"
                        [primaryYAxis]="productYAxis"
                        [zoomSettings]="zoomSettings"
                        [tooltip]="{ enable: true }"
                        [width]="widthValue"
                        [height]="heightValue"
                        (textRender)="chartUtils.onTextRender($event)"
                        (axisLabelRender)="chartUtils.onAxisLabelRender($event)"
                        [tooltip]="{ enable: true }"
                        (tooltipRender)="chartUtils.onTooltipRender($event)"
                        (load)="chartLoad($event)">
                        <e-series-collection>
                            <e-series
                                [dataSource]="salesProductList"
                                type="Column"
                                xName="productName"
                                yName="sales"
                                name="Cashback"
                                [marker]="{ dataLabel: { visible: true } }">
                            </e-series>
                        </e-series-collection>
                    </ejs-chart>
                </ng-template>
            </ng-template>
        </e-panel>

        <e-panel [sizeX]="3" [sizeY]="1" [row]="3" [col]="0">
            <ng-template #header>
                <div style="display: flex; justify-content: space-between; align-items: center">
                    <span>Cashback By Store</span>
                    <span style="font-weight: bold">
                        Total Sales :
                        {{ sumSales(salesStoreList) | currency: 'ZAR' : 'symbol' : '1.2-2' }}
                    </span>
                </div>
            </ng-template>
            <ng-template #content>
                <div
                    class="syncfusion-progressbar"
                    *ngIf="isBusy; else topStoresContainer">
                    <ejs-progressbar
                        id="topStoresProgressBar"
                        [type]="progressBarType"
                        [height]="progressBarHeight"
                        [value]="progressBarValue"
                        [progressColor]="progressColor"
                        [isIndeterminate]="isIndeterminate"
                        [animation]="animation">
                    </ejs-progressbar>
                </div>
                <ng-template #topStoresContainer>
                    <ejs-chart
                        *ngIf="chartReady && salesStoreList?.length > 0"
                        #storeChart
                        id="cashbackByStoreChart"
                        [primaryXAxis]="storeXAxis"
                        [primaryYAxis]="storeYAxis"
                        [zoomSettings]="zoomSettings"
                        [tooltip]="{ enable: true }"
                        [width]="widthValue"
                        [height]="heightValue"
                        (textRender)="chartUtils.onTextRender($event)"
                        (axisLabelRender)="chartUtils.onAxisLabelRender($event)"
                        [tooltip]="{ enable: true }"
                        (tooltipRender)="chartUtils.onTooltipRender($event)"
                        (load)="chartLoad($event)">
                        <e-series-collection>
                            <e-series
                                [dataSource]="salesStoreList"
                                type="Column"
                                xName="storeName"
                                yName="sales"
                                name="Cashback"
                                [marker]="{ dataLabel: { visible: true } }">
                            </e-series>
                        </e-series-collection>
                    </ejs-chart>
                </ng-template>
            </ng-template>
        </e-panel>
    </e-panels>
</ejs-dashboardlayout>
